/**
 * 공지 REST API (codam_admin server/notices-api.mjs 와 동일 계약).
 *
 * 로컬: package.json proxy → http://127.0.0.1:5050 (`npm run api` 별도 실행)
 * 운영: REACT_APP_NOTICES_API_URL=https://admin.codam.co.kr
 */
const trimBase = (process.env.REACT_APP_NOTICES_API_URL || '').replace(/\/$/, '')

export function noticesApiPath(path) {
    const p = path.startsWith('/') ? path : `/${path}`
    if (!trimBase) return p
    return `${trimBase}${p}`
}

export async function fetchNoticesList() {
    const r = await fetch(noticesApiPath('/api/notices'), { cache: 'no-store' })
    if (!r.ok) throw new Error(`notices ${r.status}`)
    const j = await r.json()
    const items = j.items
    return Array.isArray(items) ? items : []
}

export async function fetchNoticeById(id) {
    if (!id) return null
    const r = await fetch(noticesApiPath(`/api/notices/${encodeURIComponent(id)}`), { cache: 'no-store' })
    if (r.status === 404) return null
    if (!r.ok) throw new Error(`notice ${r.status}`)
    const j = await r.json()
    return j.item ?? null
}

export async function postNoticeViewIncrement(id) {
    if (!id) return null
    const r = await fetch(noticesApiPath(`/api/notices/${encodeURIComponent(id)}/views`), {
        method: 'POST',
        cache: 'no-store',
    })
    if (r.status === 404) return null
    if (!r.ok) throw new Error(`views ${r.status}`)
    const j = await r.json()
    return j.item ?? null
}
